import * as React from "react";
import { Path, Rect, G, Defs, ClipPath } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const BYIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="BY" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#73BE4A"
        fillRule="evenodd"
        d="M0 0h16v12H0V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#AF0100"
        fillRule="evenodd"
        d="M0 0v8h16V0H0Z"
        clipRule="evenodd"
      />
      <Path fill="#F7FCFF" d="M0 0h3v12H0z" />
      <Path
        fill="#D0181A"
        d="M.5 11a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1Zm2 0a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1Zm-1-1a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1Zm-1-1a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1Zm2 0a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1Zm-1-1a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1Zm.031-2.524 1.43-1.421L3 4v1l-.945 1.019L3 7v1l.021.047-1.476-1.479L.219 8H0V7l.99-.986L0 5.022V4h.11L1.53 5.476ZM1.5 3a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1Zm-1-1a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1Zm2 0a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1Zm-1-1a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1Zm-1-1a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1Zm2 0a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1Z"
      />
      <Path
        fill="#8F181A"
        d="M1 12H0v-1h1v1Zm2 0H2v-1h1v1Zm-2-2H0V9h1v1Zm0-2H0V7h1v1Zm0-3H0V4h1v1Zm0-2H0V2h1v1Zm0-2H0V0h1v1Zm2 0H2V0h1v1Z"
        opacity={0.4}
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
